import { createTheme } from '@mui/material/styles';

const customTheme = createTheme({
  palette: {
    
    primary: {
      main:    '#7c3aed',     
      lighter: '#e9d5ffff',  
      light:   '#b081fcff',  
      dark:    '#6d28d9',     
      darker:  '#5b21b6',     
      contrastText: '#ffffff',
    },
    secondary: {
      main: '#693640',
      light: '#b38f96',
      lighter: '#f5d3d9',
      dark: '#5c2832',
      darker: '#4d1e27',
      contrastText: '#ffffff',
    },

    info:{
      main: '#326debff',     
      lighter: '#c7ddfaff',  
      light:   '#8fbef8ff',
      dark:    '#2759e2ff',
      darker:  '#234accff',
      contrastText: '#ffffff',
    },
    success: {
      main:    '#06b6d4', // cyan-500
      lighter: '#cffafe', // cyan-100
      light:   '#67e8f9', // cyan-400
      dark:    '#0e7490', // cyan-700
      darker:  '#155e75', // cyan-800

      // main:    '#0991d4', // cyan with slight purple bias
      // lighter: '#d0f4fb', // still soft aqua, hint lavender tint
      // light:   '#6fd0f7', // cyan-light but closer to sky-violet
      // dark:    '#0d6f99', // teal-cyan with mild indigo tone
      // darker:  '#164c66', // deep teal with purple undertone

      contrastText: '#FFFFFF',
    },
    warning:{
      main: '#b88749',
      light: '#d49b54',
      lighter: '#efb05f',
      dark: '#9c733e',
      darker: '#815f33',
      contrastText: '#ffffff',
    },
    error:{
      // main:    '#b91c1c', // deep crimson
      // lighter: '#fee2e2',
      // light:   '#fca5a5',
      // dark:    '#7f1d1d',
      // darker:  '#450a0a',

      // main:    '#e11d48', // rose-600
      // lighter: '#ffe4e6', // rose-100
      // light:   '#fb7185', // rose-400
      // dark:    '#be123c', // rose-700
      // darker:  '#881337', // rose-800

      // main:    '#f97316', // orange-500
      // lighter: '#ffedd5', // orange-100
      // light:   '#fdba74', // orange-300
      // dark:    '#c2410c', // orange-700
      // darker:  '#7c2d12', // orange-800


      main:    '#d61f69', // magenta-rose (purple-leaning red)
      lighter: '#fde4f5', // very light lavender-pink
      light:   '#f472b6', // pink-magenta
      dark:    '#be185d', // deep rose-purple
      darker:  '#940e58ff', // plum-rose


      contrastText: '#ffffff',
    },

    gradients: {
      success: "linear-gradient(90deg, var(--mui-palette-success-main), var(--mui-palette-success-dark))",
    },
    
    // primary: {
    //   main: '#0b1e9e', 
    //   light: '#aabbff',
    //   lighter: '#adf7ee',
    //   dark: '#091A7A',
    //   darker: '#0a164e',
    // },
    // secondary: {
    //   main: '#b0a8ba',
    //   light: '#ece1f0',
    //   lighter: '#fdf7ff',
    //   dark: '#9d94a8',
    //   darker: '#887e94',
    // },
    // info:{
    //   main: '#4B97C9',    // A medium blue to indicate informational messages
    //   light: '#78B3DC',   // Lighter shade for backgrounds or accents
    //   lighter: '#B8DBF0', // Very light shade for subtle backgrounds
    //   dark: '#3579A3',    // Darker shade for text or emphasis
    //   darker: '#205378',  // The darkest version for strong contrast
    //   contrastText: '#fff' // Use white text for contrast against these shades
    // },
    // success: {
    //   main: '#2E7D32',    // A medium green indicating success
    //   light: '#66BB6A',   // A lighter green for background accents
    //   lighter: '#A5D6A7', // Very light green for subtle success backgrounds
    //   dark: '#1B5E20',    // A darker green for text or emphasis
    //   darker: '#104314',  // The darkest version for the strongest contrast
    //   contrastText: '#fff' // White text to ensure readability
    // },
    // warning: {
    //   main: '#E0A800',    // A warm amber color for warnings
    //   light: '#F1C04D',   // A lighter yellow for background warnings
    //   lighter: '#FBE2A2', // Very light yellow for soft warnings
    //   dark: '#B38400',    // A darker shade for warning text
    //   darker: '#7A5B00',  // The darkest version for deep contrast
    //   contrastText: '#fff' // White text provides good r
    // },
    // error: {
    //   main: '#D32F2F',    // A strong red to indicate errors
    //   light: '#E57373',   // A lighter red for background highlights
    //   lighter: '#F4B8B8', // Very light red for softer error backgrounds
    //   dark: '#B71C1C',    // Darker red for text or emphasis
    //   darker: '#7F0000',  // Deepest red for the strongest contrast
    //   contrastText: '#fff' // White text for contrast against red tones
    // },

    text: {
      primary: '#525860',
      secondary: '#a0a0a0',
    },
  },
  spacing: (value) => value * 8, // 8px grid system
});

export {customTheme};
